import {
  Button,
  DatePicker,
  Empty,
  Popconfirm,
  Select,
  Space,
  Spin,
  Table,
  Typography
} from "antd";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { getMenuDatas } from "../slice";
import { AppDispatch, RootState } from "../../../../../app/store";
import { useDispatch, useSelector } from "react-redux";
import menusAdmin from "../../../../../apis/admin/menuService";
import notificationHandler from "../../../../atoms/Notification";
import {
  DeleteOutlined,
  FormOutlined,
  LoadingOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import kitchenAdmin from "../../../../../apis/admin/kitchenService";
import "moment/locale/vi";
import locale from "antd/es/date-picker/locale/vi_VN";
import "../menu.scss";
import moment from "moment";
import { ColumnsType } from "antd/lib/table";

interface DataType {
  index: string;
  foodList: string;
  applicableDate: string;
  action: string;
}

const ListMenu = () => {
  const { menus }: any = useSelector((state: RootState) => state.menulist);
  const dispatch = useDispatch<AppDispatch>();
  const dateFormat = "DD-MM-YYYY";
  const { RangePicker } = DatePicker;
  const [KitchenId, setKitchenId] = React.useState<any>("");
  const [dataKitchen, setDataKitchen] = React.useState<any>();
  const [dateString, setDateString] = React.useState<any>([]);
  const [loading, setLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);

  const handlePageChange = (page: any) => {
    setCurrentPage(page);
  };

  const [pageSize, setPageSize] = React.useState(10);

  const displayedIndex = (index: any) =>
    (currentPage - 1) * pageSize + index + 1;

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
  );

  const { Title } = Typography;

  useEffect(() => {
    setLoading(true)
    dispatch(getMenuDatas({ fromDate: "", toDate: "", kitchenId: KitchenId, isSpecial: '1' }))
      .then(() => { })
      .catch((err: any) => {
        notificationHandler("error", err.response.data.data.msg_content);
      }).finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    kitchenAdmin
      .getKitchenData(1, "")
      .then((data: any) => {
        setDataKitchen(data.data.data.payload);
      })
      .catch((err: any) => {
        notificationHandler("error", err.response.data.data.msg_content);
      });
  }, [dispatch]);

  const confirm = (id: number) => {
    setLoading(true);
    menusAdmin
      .removeMenu(id)
      .then(() => {
        dispatch(
          getMenuDatas({
            fromDate: dateString[0] || "",
            toDate: dateString[1] || "",
            kitchenId: KitchenId,
            isSpecial: '1'
          })
        );
        notificationHandler("success", "Xóa thực đơn thành công");
        setLoading(false);
      })
      .catch((err) => {
        notificationHandler("error", err.response.data.data.msg_content);
        setLoading(false);
      });
  };
  const onchangeDate = (date: any, dateString: any) => {
    setDateString(dateString);
    dispatch(
      getMenuDatas({
        fromDate: dateString[0],
        toDate: dateString[1],
        kitchenId: KitchenId || "",
        isSpecial: '1'
      })
    )
      .unwrap()
      .then((item) => {
        setCurrentPage(1);
      });
  };
  const handleMenu = (value: any) => {
    if (value == undefined) value = ''
    setKitchenId(value);
    dispatch(
      getMenuDatas({
        fromDate: dateString[0] || "",
        toDate: dateString[1] || "",
        kitchenId: value,
        isSpecial: '1'
      })
    )
      .unwrap()
      .then((item) => {
        setCurrentPage(1);
      });
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      width: "5%",
      align: "center",
      render: (_: any, __: any, index: any) => displayedIndex(index),
    },
    {
      title: "Bữa",
      dataIndex: "menuType",
      key: "menuType",
      width: "20%",
      align: "center",
      render: (text: any, __: any, index: any) => {
        return (
          <div key={index} className="flex flex-col">
            <span className="mx-auto">
                {text == 1 ? 'Sáng' : (text == 2 ? 'Trưa' : '') }
              </span>
          </div>
        )
      },
    },
    {
      title: "Món ăn",
      dataIndex: "foodList",
      key: "foodList",
      width: "10%",
      align: "center",
      render: (text: any, object: any, index: number) => {
        return (
          <div key={index} className="flex flex-col">
            <span className="truncates mx-auto">
                {text}
              </span>
          </div>
        );
      },
    },
    {
      title: "Ngày áp dụng",
      dataIndex: "applicableDate",
      key: "applicableDate",
      align: "center",
      width: "38%",
      render: (text: any, object: any, index: number) => {
        const applicableDate = moment(text).format("DD-MM-YYYY");
        return <div>{applicableDate}</div>;
      },
    },
    {
      title: "Hành Động",
      dataIndex: "action",
      align: "center",
      width: "8%",
      render: (text: string, record: any) => {
        return (
          <Space size="small">
            <Button className="mr-1 hover:border-[#FAAD14] hover:text-[#FAAD14] bg-[#FAAD14] border-[#FAAD14] p-[5px_10px] text-white ">
              <Link
                to={`/admin/editMenuSpecial/${record.id}`}
                className="flex items-center"
              >
                <FormOutlined className="mr-1" />
                Sửa
              </Link>
            </Button>
            <Popconfirm
              title="Bạn có muốn xóa thực đơn?"
              onConfirm={() => confirm(record.id)}
              okText="Có"
              cancelText="Không"
              okType="danger"
            >
              <Button
                danger
                className="bg-[#ff4d4f] text-white "
                loading={loading}
              >
                <div className="flex items-center">
                  <DeleteOutlined className="pr-1" />
                  Xóa
                </div>
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  return (
    <div id="menu">
      <Spin indicator={antIcon} spinning={loading} />
      <div className="flex justify-between">
        <div className="w-[80%]">
          <div className="flex header-select">
            <RangePicker
              onChange={onchangeDate}
              placeholder={["Chọn ngày bắt đầu ", "Chọn ngày kết thúc"]}
              format={dateFormat}
              className="w-[80%] max-w-[350px]"
              locale={locale}
            />
            <Select
              className="w-[40%] max-w-[250px] ml-4 select-kitchen"
              placeholder="Chọn bếp ăn"
              onChange={handleMenu}
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input: string, option: any) => (option?.label ?? '').toLowerCase().includes(input.trim())}
              options={dataKitchen?.map((item: any, key: number) => ({
                value: item.id,
                label: item.kitchenName,
              }))}
            >
              {/* <Select.Option value={""}>Chọn bếp ăn</Select.Option>
              {dataKitchen?.map((item: any, key: number) => (
                <Select.Option key={key} value={item.id} label={item.kitchenName}>
                  <span className="truncate">{item.kitchenName}</span>
                </Select.Option>
              ))} */}
            </Select>
          </div>
        </div>
        <Button className="p-[5px_15px] border-green-600 hover:border-green-600 hover:text-green-600 hover:bg-white bg-green-600 text rounded-sm text-white">
          <Link
            to={"/admin/createMenuSpecial"}
            className="flex items-center hover:text-white"
          >
            <PlusCircleOutlined className="mr-1" />
            Thêm mới
          </Link>
        </Button>
      </div>
      <Title className='mt-[30px]' level={3}>Danh sách thực đơn đặc biệt</Title>
      <Table
        className="mt-[15px]"
        dataSource={menus}
        columns={columns}
        pagination={{
          locale: { items_per_page: "bản ghi / Trang" },
          current: currentPage,
          defaultPageSize: 10,
          onShowSizeChange(current, size) {
            setPageSize(size)
          },
          onChange: handlePageChange,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
          showTotal: (total: any, range: any) =>
            `${range[0]}-${range[1]} Tổng ${total} bản ghi`,
        }}
        rowKey={(record: any) => record.id}
        locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_DEFAULT} description="Không có dữ liệu!" /> }}
      />
    </div>
  );
};

export default ListMenu;
